import React from "react";
import "./ProgressLoader.css";
export default function ProgressLoader() {
  return (
    <div class="progress mx-auto">
      <div class="progress-bar" style={{ width: "100%" }}></div>
    </div>
  );
}
